import React from 'react';
import { useAtom } from 'jotai/index';
import classNames from 'classnames';
import moment from 'moment';
import styles from '../css/index.module.scss';
import { widgetInputsAtom, widgetParamsAtom, widgetSelectedLanguageAtom } from '../../../atoms/widgetAtoms';
import useWidget from '../../../hooks/UseWidget';
import WT from '../constants/widgetTranslations';
import EmptyHeight from '../../../components/EmptyHeight';
import PartnersServices from '../../../services/PartnersServices';
import makeFirstUppercase from '../../../helpers/makeFirstUppercase';
import MyInput from '../../../components/MyInput';

function WidgetInputsState() {
  const { t } = useWidget();
  const [widgetParams] = useAtom(widgetParamsAtom);
  const [widgetInputs, setWidgetInputs] = useAtom(widgetInputsAtom);
  const [widgetSelectedLanguage] = useAtom(widgetSelectedLanguageAtom);

  return (
    <>
      <div className={styles.inputsState}>
        <p className={styles.inputsTitle}>
          {makeFirstUppercase(moment(widgetParams.date).format('dddd, DD MMMM'))}
          {' '}
          {PartnersServices.convertSecondsToFormat(widgetInputs.slot)}
          ,
          {' '}
          {widgetParams.persons}
          {' '}
          {t(WT.person, widgetParams.persons)}
        </p>
        <EmptyHeight height={50} />

        <MyInput
          value={widgetInputs.name}
          onChange={(ev) => setWidgetInputs({ name: ev.target.value })}
          labelTextTop={t(WT.yourName)}
          placeholder={t(WT.namePlaceholder)}
          withLeftIcon={false}
          wrapperClassName={classNames(styles.input)}
          forWidget
        />
        <EmptyHeight height={50} />

        <MyInput
          value={widgetInputs.phoneNumber}
          onChange={(ev) => setWidgetInputs({ phoneNumber: ev.target.value })}
          labelTextTop={t(WT.yourNumber)}
          placeholder="+7"
          withLeftIcon={false}
          wrapperClassName={classNames(styles.input)}
          forWidget
          mask="+7 999 999 99 99"
        />
        <EmptyHeight height={23} />

        <MyInput
          value={widgetInputs.comment}
          onChange={(ev) => setWidgetInputs({ comment: ev.target.value })}
          placeholder={t(WT.bookingRequests)}
          withLeftIcon={false}
          wrapperClassName={classNames(styles.input, styles.inputLarge)}
          isLarge
          forWidget
        />
      </div>
    </>
  );
}

export default WidgetInputsState;
